module.exports = __webpack_public_path__ + "gq.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gq.svg
// module id = 832
// module chunks = 0